import type { IconData } from '@stacksjs/iconify-core'

export const arrowRight: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m65 8l311 311L65 630L0 564l245-245L0 74z\"/>",
  "width": 380,
  "height": 790,
  "viewBox": "0 0 380 790"
}

export default arrowRight
